import React, { useState } from "react";
import { Button, Form, } from 'react-bootstrap';
import './StepTwo.scss';
import '../StepOne/StepOne.scss';
import ScrollAnimation from 'react-animate-on-scroll';
import "react-datepicker/dist/react-datepicker.css";
import enGb from "date-fns/locale/en-GB";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";

registerLocale("en-gb", enGb);

const SimpleDatePicker = ({ value, onChange }) => {
  const defaultDate = moment().add(2, "days").toDate();
  const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : defaultDate);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onChange(moment(date).format("YYYY-MM-DD")); // pass formatted date back
  };

  return (
    <div className="simple-date-picker">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        minDate={moment().add(1, "days").toDate()}
        dateFormat="dd/MM/yyyy"
        locale="en-gb"
        placeholderText="Select a date"
        inline
        name="expectedDate"
      />
    </div>
  );
};

const StepTwo = (props) => {

  return (

    <div className="steptwo">
      <div className="d-lg-block">
        <div onClick={props.handleBack} onKeyPress={props.handleBack} className="back_icon"><i className="icon-back"></i> Back to Property Details</div>
      </div>
      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <h2><span>Thanks {props.name}. We now need</span> to know how we can best help you.</h2>
      </ScrollAnimation>
      <div className="form-field">
        <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
          {props?.type === "sale" && (
            <>
              <div className="option-bx">
                <h3>Have you got a property to sell?</h3>
                <div className="d-flex">
                  <Form.Group controlId="sellYes">
                    <Form.Check
                      onChange={props.onChange}
                      inline
                      checked={props.propertySell === 'Yes'}
                      type="radio"
                      value="Yes"
                      name="propertysell"
                      label="Yes" />
                  </Form.Group>
                  <Form.Group controlId="sellNo">
                    <Form.Check
                      onChange={props.onChange}
                      checked={props.propertySell === 'No'}
                      inline
                      type="radio"
                      value="No"
                      name="propertysell"
                      label="No" />
                  </Form.Group>
                  {!props.propertySell && props.submitted &&
                    <div className="error">
                      Please choose an option.
                    </div>
                  }
                </div>
              </div>
              {props.propertySell === 'Yes' &&
                <div className="option-bx">
                  <h3>Is it on the market?</h3>
                  <div className="d-flex">
                    <Form.Group controlId="marketYes">
                      <Form.Check
                        onChange={props.onChange}
                        checked={props.market === 'Yes'}
                        inline
                        type="radio"
                        name="market"
                        label="Yes"
                        value="Yes" />
                    </Form.Group>
                    <Form.Group controlId="marketNo">
                      <Form.Check
                        onChange={props.onChange}
                        inline
                        checked={props.market === 'No'}
                        type="radio"
                        name="market"
                        label="No"
                        value="No" />
                    </Form.Group>
                    {!props.market && props.submitted &&
                      <div className="error">
                        Please choose an option.
                      </div>
                    }
                  </div>
                </div>
              }
              <div className="option-bx">
                <h3>How are you funding your purchase?</h3>
                <div className="d-flex">
                  <Form.Group controlId="purchaseYes">
                    <Form.Check
                      onChange={props.onChange}
                      inline
                      type="radio"
                      name="purchase"
                      label="Mortgage"
                      checked={props.purchase === 'Mortgage'}
                      value="Mortgage" />
                  </Form.Group>
                  <Form.Group controlId="purchaseNo">
                    <Form.Check
                      onChange={props.onChange}
                      inline
                      type="radio"
                      name="purchase"
                      label="Cash Funds"
                      checked={props.purchase === 'Cash Funds'}
                      value="Cash Funds" />
                  </Form.Group>
                  {!props.purchase && props.submitted &&
                    <div className="error">
                      Please choose an option.
                    </div>
                  }
                </div>
              </div>
              {props.purchase === 'Mortgage' &&
                <div className="option-bx">
                  <h3>Do you need a mortgage?</h3>
                  <div className="d-flex">
                    <Form.Group controlId="mortgageYes">
                      <Form.Check
                        onChange={props.onChange}
                        checked={props.mortgage === 'Yes'}
                        inline
                        type="radio"
                        name="mortgage"
                        label="Yes"
                        value="Yes" />
                    </Form.Group>
                    <Form.Group controlId="mortgageNo">
                      <Form.Check
                        onChange={props.onChange}
                        checked={props.mortgage === 'No'}
                        inline
                        type="radio"
                        name="mortgage"
                        label="No"
                        value="No" />
                    </Form.Group>
                    {!props.mortgage && props.submitted &&
                      <div className="error">
                        Please choose an option.
                      </div>
                    }
                  </div>

                </div>
              }
            </>
          )}

          {/* Tenant Property */}
          {props?.type === "lettings" && (
            <>
              <div className="form-section">
                <div className="form-block-col">
                  <Form.Group>
                    <Form.Control className={props.monthlyBudgetError ? 'error-border' : ''} autoComplete="off" value={props.monthlyBudget} onChange={props.onChange} name="monthlyBudget" type="number" placeholder="Monthly budget (£)" />
                    {props.monthlyBudgetError &&
                      <div className="error">
                        Please Enter Your Monthly Budget.
                      </div>
                    }
                  </Form.Group>
                  <Form.Group>
                    <Form.Control className={props.stayDurationError ? 'error-border' : ''} autoComplete="off" value={props.stayDuration} onChange={props.onChange} name="stayDuration" type="number" placeholder="Stay duration (months)" />
                    {props.stayDurationError &&
                      <div className="error">
                        Please Enter Stay Duration.
                      </div>
                    }
                  </Form.Group>


                  <div className="option-bx">
                    <h3>Expected Date of check in?</h3>
                    <div className="d-flex">
                      <SimpleDatePicker
                        value={props.expectedDate}
                        onChange={(date) =>{ props.setExpectedDate(date); sessionStorage.setItem('expectedDate',date)}}
                      />

                      {!props.expectedDate && props.submitted && (
                        <div className="error">Please choose an date.</div>
                      )}
                    </div>
                  </div>

                  {/* Employment status */}
                  <div className="option-bx">
                    <h3>Are you currently employed or a student?</h3>
                    <div className="d-flex">
                      <Form.Group controlId="employmentEmployed">
                        <Form.Check
                          onChange={props.onChange}
                          inline
                          checked={props.employmentStatus === 'Employed'}
                          type="radio"
                          value="Employed"
                          name="employmentStatus"
                          label="Employed"
                        />
                      </Form.Group>
                      <Form.Group controlId="employmentStudent">
                        <Form.Check
                          onChange={props.onChange}
                          inline
                          checked={props.employmentStatus === 'Student'}
                          type="radio"
                          value="Student"
                          name="employmentStatus"
                          label="Student"
                        />
                      </Form.Group>
                      {/* <Form.Group controlId="employmentOther">
                        <Form.Check
                          onChange={props.onChange}
                          inline
                          checked={props.employmentStatus === 'Other'}
                          type="radio"
                          value="Other"
                          name="employmentStatus"
                          label="Other"
                        />
                      </Form.Group> */}
                      {!props.employmentStatus && props.submitted && (
                        <div className="error">Please choose an option.</div>
                      )}
                    </div>
                  </div>

                  {/* If Employed, ask for job role and income */}
                  {props.employmentStatus === 'Employed' && (
                    <div className="form-section">
                      <Form.Group>
                        <Form.Control
                          className={props.jobRoleError ? 'error-border' : ''}
                          autoComplete="off"
                          value={props.jobRole}
                          onChange={props.onChange}
                          name="jobRole"
                          type="text"
                          placeholder="What is your job role?"
                        />
                        {props.jobRoleError && <div className="error">Please enter your job role.</div>}
                      </Form.Group>
                      <Form.Group>
                        <Form.Control
                          className={props.incomeError ? 'error-border' : ''}
                          autoComplete="off"
                          value={props.income}
                          onChange={props.onChange}
                          name="income"
                          type="number"
                          placeholder="What is your monthly income? (in £)"
                        />
                        {props.incomeError && <div className="error">Please enter your income.</div>}
                      </Form.Group>
                    </div>
                  )}
                  <div className="option-bx">
                    <h3>Will anyone else be living with you?</h3>
                    <div className="d-flex">
                      <Form.Group controlId="extrapeopleYes">
                        <Form.Check
                          onChange={props.onChange}
                          inline
                          checked={props.extraPeople === 'Yes'}
                          type="radio"
                          value="Yes"
                          name="extraPeople"
                          label="Yes" />
                      </Form.Group>
                      <Form.Group controlId="extrapeopleNo">
                        <Form.Check
                          onChange={props.onChange}
                          checked={props.extraPeople === 'No'}
                          inline
                          type="radio"
                          value="No"
                          name="extraPeople"
                          label="No" />
                      </Form.Group>
                      {!props.extraPeople && props.submitted &&
                        <div className="error">
                          Please choose an option.
                        </div>
                      }
                    </div>
                  </div>
                  {/* pets */}
                  <div className="option-bx">
                    <h3>Do You Have Pets?</h3>
                    <div className="d-flex">
                      <Form.Group controlId="petsYes">
                        <Form.Check
                          onChange={props.onChange}
                          inline
                          checked={props.pets === 'Yes'}
                          type="radio"
                          value="Yes"
                          name="pets"
                          label="Yes" />
                      </Form.Group>
                      <Form.Group controlId="petsNo">
                        <Form.Check
                          onChange={props.onChange}
                          checked={props.pets === 'No'}
                          inline
                          type="radio"
                          value="No"
                          name="pets"
                          label="No" />
                      </Form.Group>
                      {!props.pets && props.submitted &&
                        <div className="error">
                          Please choose an option.
                        </div>
                      }
                    </div>
                  </div>
                  {/* smoke  */}
                  <div className="option-bx">
                    <h3>Do You Smoke?</h3>
                    <div className="d-flex">
                      <Form.Group controlId="smokingYes">
                        <Form.Check
                          onChange={props.onChange}
                          inline
                          checked={props.smoking === 'Yes'}
                          type="radio"
                          value="Yes"
                          name="smoking"
                          label="Yes" />
                      </Form.Group>
                      <Form.Group controlId="smokingNo">
                        <Form.Check
                          onChange={props.onChange}
                          checked={props.smoking === 'No'}
                          inline
                          type="radio"
                          value="No"
                          name="smoking"
                          label="No" />
                      </Form.Group>
                      {!props.smoking && props.submitted &&
                        <div className="error">
                          Please choose an option.
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>

            </>
          )}
          <div className="flex-btn">
            <Button className="order-btn-2" variant="primary" onClick={props.previous}>Back</Button>
            <Button className="order-btn-1" onClick={props.next} variant="primary" >
              Next Step
            </Button>
          </div>
        </ScrollAnimation>
      </div>
    </div>
  )
}



export default StepTwo